import { axiosInstanceWebsite } from "@/services/instance";
import type { AdStyle, StyleTab } from "../components/modals/steps/adStudio/types";
import { MOCK_STYLES, getStylesByCategory } from "../components/modals/steps/adStudio/stylesData";

interface ApiTemplate {
  id: string;
  image_url: string;
  name?: string;
  name_id?: string;
  category?: string;
  is_custom?: boolean;
  is_active?: boolean;
  metadata?: {
    primary_color?: string;
    background_color?: string;
    [key: string]: any;
  };
}

function normalizeApiTemplate(t: ApiTemplate): AdStyle {
  const isCustomUpload = t.is_custom ?? (t.category === "custom" || t.name_id === "custom-reference");
  return {
    id: String(t.id),
    coverImage: t.image_url,
    name: t.name ?? "Estilo",
    name_id: t.name_id,
    category: t.category,
    image_url: t.image_url,
    isCustomUpload,
    metadata: t.metadata,
  };
}

const CUSTOM_REFERENCE_STYLE = MOCK_STYLES.find(
  (s) => s.id === "custom-reference" && s.isCustomUpload
)!;

async function fetchTemplates(category?: StyleTab): Promise<ApiTemplate[]> {
  const params = category && category !== "all" ? { category } : {};
  const response = await axiosInstanceWebsite.get("/ads/creatives/templates", { params });
  const raw = response.data;
  return Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
}

export const templatesService = {
  async getTemplates(category?: StyleTab): Promise<AdStyle[]> {
    try {
      const items = await fetchTemplates(category);

      if (items.length === 0) {
        return category ? getStylesByCategory(category) : MOCK_STYLES;
      }

      const styles = items
        .filter((t) => t.is_active !== false && Boolean(t.image_url?.trim()))
        .map(normalizeApiTemplate);
      const hasCustomRef = styles.some((s) => s.id === "custom-reference" && s.isCustomUpload);
      return hasCustomRef ? styles : [...styles, CUSTOM_REFERENCE_STYLE];
    } catch {
      return category ? getStylesByCategory(category) : MOCK_STYLES;
    }
  },
};
